import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DraftBase } from "../types";

export interface AuthReducer {
  token: string | null;
  signatureRequestId: number | null;
  draftBase: DraftBase | null;
}
const initialState: AuthReducer = {
  token: null,
  signatureRequestId: null,
  draftBase: null,
};

const authSlice = createSlice({
  name: "authentications",
  initialState,
  reducers: {
    updateToken: (state, action) => {
      state.token = action.payload;
    },
    updateSignatureRequestId: (state, action) => {
      state.signatureRequestId = action.payload;
    },
    updateDraftBase: (state, action: PayloadAction<DraftBase | null>) => {
      state.draftBase = action.payload;
    },
  },
});

export const { updateToken, updateSignatureRequestId, updateDraftBase } =
  authSlice.actions;

export default authSlice.reducer;
